// Popular stops (pods / food-cart parks) per city, keyed by the
// ConfigContext `city_name`. One list per city so the footer's "Popular
// locations" block and the near-me dropdown never show another city's
// spots — the footer used to hardcode Austin's five on every site.
//
// Order matters: the footer shows the first FOOTER_COUNT entries. Keep the
// spots that have a live /schedule page at the top.

export const FOOTER_COUNT = 5;

const SEATTLE_STOPS = [
  { name: 'Westlake Park', link: '/schedule/westlake-park' },
  { name: 'The Polyclinic', link: '/schedule/the-polyclinic-madison-center' },
  { name: 'Starbucks Center', link: '/schedule/starbucks-center' },
  { name: 'Villa Marina', link: '/schedule/villa-marina' },
  { name: 'T-Mobile Campus', link: '/schedule/t-mobile-campus-factoria' },
  { name: 'Rooftop Brewing', link: '/schedule/rooftop-brewing-company' },
  { name: "Chuck's Hop Shop", link: '/schedule/chuck-s-hop-shop-greenwood' },
  { name: 'Boeing Campus', link: '/schedule/boeing-campus' },
  { name: 'Urban Family Brewing', link: '/schedule/urban-family-brewing-co' },
  { name: 'Broadview Tap House', link: '/schedule/broadview-tap-house' },
  { name: "Saleh's", link: '/schedule/salehs' },
];

const PORTLAND_STOPS = [
  { name: 'Cartopia', link: '/schedule/cartopia-food-cart-pod' },
  { name: 'Pioneer Courthouse Square', link: '/schedule/pioneer-courthouse-square-food-cart-pod' },
  { name: 'Cartlandia', link: '/schedule/cartlandia-food-cart-pod' },
  { name: 'Hawthorne Asylum', link: '/schedule/hawthorne-asylum' },
  { name: 'Portland Mercado', link: '/schedule/portland-mercado' },
  { name: 'Prost Marketplace', link: '/schedule/prost-marketplace' },
  { name: 'Fifth Avenue Food Cart Pod', link: '/schedule/fifth-avenue-food-cart-pod' },
  { name: 'St Johns Food & Beer Porch', link: '/schedule/st-johns-food-beer-porch' },
  { name: 'Third Avenue Food Cart Pod', link: '/schedule/third-avenue-food-cart-pod' },
  { name: 'Portland State University', link: '/schedule/portland-state-university-food-cart-pod' },
];

const AUSTIN_STOPS = [
  { name: 'Arbor Food Park', link: '/schedule/arbor-food-park' },
  { name: 'The Picnic', link: '/schedule/the-picnic' },
  { name: 'East 6th Food Truck Park', link: '/schedule/east-6th-food-truck-park' },
  { name: 'Cosmic Coffee', link: '/schedule/cosmic-coffee-beer-garden' },
  { name: 'Meanwhile Brewing', link: '/schedule/meanwhile-brewing' },
];

const STOPS_BY_CITY = {
  seattle: SEATTLE_STOPS,
  portland: PORTLAND_STOPS,
  austin: AUSTIN_STOPS,
};

// Unknown or missing city returns an empty list: the footer then shows only
// "All locations" rather than another city's spots.
export function popularStopsFor(cityName) {
  const key = typeof cityName === 'string' ? cityName.trim().toLowerCase() : '';
  return STOPS_BY_CITY[key] || [];
}

export function footerStopsFor(cityName) {
  return popularStopsFor(cityName).slice(0, FOOTER_COUNT);
}
